var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonDocumentEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 1.83594H8.24992C3.66659 1.83594 1.83325 3.66927 1.83325 8.2526V13.7526C1.83325 18.3359 3.66659 20.1693 8.24992 20.1693H13.7499C18.3333 20.1693 20.1666 18.3359 20.1666 13.7526V11.9193",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7032 2.76686L7.47989 9.99019C7.20489 10.2652 6.92989 10.806 6.87489 11.2002L6.48072 13.9594C6.33406 14.9585 7.03989 15.6552 8.03906 15.5177L10.7982 15.1235C11.1832 15.0685 11.7241 14.7935 12.0082 14.5185L19.2316 7.29519C20.4782 6.04852 21.0649 4.60019 19.2316 2.76686C17.3982 0.933523 15.9499 1.52019 14.7032 2.76686Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6675 3.80469C14.2816 5.99552 15.9958 7.70969 18.1958 8.33302",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDocumentEdit);
export default __webpack_public_path__ + "static/media/button-document-edit.7b9fe57f311d6e3b2f4b4fc4cffc1451.svg";
export { ForwardRef as ReactComponent };